export default function LifeSimIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <rect width="64" height="64" rx="12" fill="#FF8A3D" />
      {/* Open storybook */}
      <path d="M8 18c8-3 16-3 24 2v34c-8-5-16-5-24-2z" fill="#FFF6E8" />
      <path d="M56 18c-8-3-16-3-24 2v34c8-5 16-5 24-2z" fill="#FFE9CC" />
      <path d="M32 20v34" stroke="#D9773A" strokeWidth="2" />
      {/* Sprout growing out of the book */}
      <path d="M32 20c0-6 0-9 0-12" stroke="#2EA36B" strokeWidth="3" strokeLinecap="round" />
      <path d="M32 12c-6 0-9-3-9-7 5 0 9 2 9 7z" fill="#3CC47E" />
      <path d="M32 10c5 0 8-3 8-6-5 0-8 2-8 6z" fill="#3CC47E" />
      {/* Story lines and a little timeline */}
      <path d="M13 28h13M13 33h11M13 38h13" stroke="#C9A27E" strokeWidth="2" strokeLinecap="round" />
      <circle cx="40" cy="30" r="3" fill="#4D7CFF" />
      <circle cx="47" cy="37" r="3" fill="#E85D9A" />
      <circle cx="40" cy="44" r="3" fill="#2EC4B6" />
      <path d="M40 33l5 2M45 39l-3 3" stroke="#C9A27E" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}
